import React from 'react';
import '../../App.css';
import Cards from '../Cards';

export default function Photos() {
  return (
    <>
    <h1 className='photos'>PHOTOS</h1>
    <Cards />
    </>
  )
}
